import { Component, Input, OnInit } from '@angular/core';

import {
  trigger,
  style,
  animate,
  transition,
} from '@angular/animations';
import { BaseComponent } from 'src/app/moov-common/base/base.component';

@Component({
  selector: 'app-submission-success',
  templateUrl: './submission-success.component.html',
  styleUrls: ['./submission-success.component.scss'],
  animations: [
    // pop the whole card in
    trigger('popIn', [
      transition(':enter', [
        style({ transform: 'scale(0.5)', opacity: 0 }),
        animate(
          '400ms cubic-bezier(.34,1.56,.64,1)',
          style({ transform: 'scale(1)', opacity: 1 })
        ),
      ]),
    ]),
  ],
})
export class SubmissionSuccessComponent extends BaseComponent implements OnInit {
  confettis: Array<{ style: any }> = [];
  @Input() frequencyText: string = '';
  constructor() {
    super();
  }

  ngOnInit() {
    super.ngOnInit();
    this.launchConfetti();
  }

  private launchConfetti() {
    const colors = ['#FFC107', '#E91E63', '#4CAF50', '#2196F3', '#FF5722'];
    const count = 40;
    for (let i = 0; i < count; i++) {
      const delay = Math.random() * 2000;
      const left = Math.random() * 100;
      const size = 6 + Math.random() * 10;
      this.confettis.push({
        style: {
          left: `${left}%`,
          width: `${size}px`,
          height: `${size}px`,
          backgroundColor: colors[Math.floor(Math.random() * colors.length)],
          animationDelay: `${delay}ms`,
        },
      });
    }
  }
}
